import React, { useContext } from 'react';
import { OrderFlowContext } from '../../../../../../../../context/OrderFlowContext';
import { ProductTransactionStatusContext } from '../../../../../../../../context/ProductTransactionStatusContext';
import { useRequest } from '../../../../../../../../requests/common/requestHook';
import { ProductTransactionRequest } from '../../../../../../../../requests/productTransaction.request';
import { ProductTransactionFlowAction } from '../../../../../../../../types/order/productTransactionFlowAction';
import { ProductTransaction } from '../../../../../../../../types/productTransaction';
import { TranslationKey } from '../../../../../../../../types/translation/TranslationKey';
import { translate } from '../../../../../../../../types/translation/Translator';
import { Button, ButtonVariant } from '../../../../../../../components/Button';

interface ProcessProductTransactionFooterProps {
  input: ProductTransaction;

  handleClose: () => void;
}

export default function ProcessProductTransactionFooter({ input, handleClose }: ProcessProductTransactionFooterProps) {
  const { orderFlows } = useContext(OrderFlowContext);
  const { productTransactionStatuses } = useContext(ProductTransactionStatusContext);

  const [process, { loading: processLoading }] = useRequest(ProductTransactionRequest.process);
  const handleAction = async (action: ProductTransactionFlowAction) => {
    const response = await process({ data: [input.forUpdate()], statusId: action.statusId });
    if (!response) return;

    handleClose();
  };

  const flow = orderFlows.get(input.flowId);
  if (!flow) return null;

  const current = flow.productTransactionActions.find(action => action.statusId === input.statusId);
  if (!current) return null;

  const potentialNextActions = flow.productTransactionActions.filter(action =>
    action.previous.includes(current.statusId),
  );
  // .sort((a, b) => a.style.index - b.style.index);

  const rightButtons = [];
  const leftButtons = [];
  for (const nextAction of potentialNextActions) {
    const button = (
      <Button
        key={nextAction.id}
        loading={processLoading}
        onClick={() => handleAction(nextAction)}
        text={
          //   nextAction.style.text
          //     ? translate({ key: nextAction.style.text as TranslationKey })
          productTransactionStatuses.get(nextAction.statusId)?.name
        }
      />
    );

    rightButtons.push(button);
    // else leftButtons.push(button);
  }

  if (!leftButtons.length && !rightButtons.length) {
    leftButtons.push(
      <Button
        key='close'
        variant={ButtonVariant.secondary}
        onClick={handleClose}
        text={translate({ key: TranslationKey.close })}
        disabled={false}
      />,
    );
  }

  return (
    <div className='pt-6'>
      <div className='flex justify-between'>
        <div className='flex gap-2'>{leftButtons}</div>
        <div className='flex gap-2'>{rightButtons}</div>
      </div>
    </div>
  );
}
